import React from 'react';
import { graphql } from 'react-apollo';
import Spinner from '../../spinner/spinner';
import { Button, Form } from 'antd';
import UploadScriptureForm from './dailyScripturesForm';
import { getDailyScriptures } from "./queries/getDailyScriptures";
import { createDailyScripture } from './mutations/createDailyScripture';

class CreateScripturePage extends React.Component {
  mutationParams = () => {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue(),
          day: parseInt(this.props.form.getFieldsValue().day, 10)
        }
      }
    }
  };

  redirectTo = (data) => {
    this.props.history.push(`/dashboard/admin/scripturesList?scripture=${data.createDailyScripture.dailyScripture.id}`);
  };

  formControls(loading) {
    return (
      <Button type="primary" htmlType="submit" className="login-form__login-button" loading={loading}>
        Create scripture
      </Button>
    );
  }

  render() {
    if (this.props.data.loading) {
      return (
        <Spinner/>
      );
    } else {
      return (
        <UploadScriptureForm {...this.props } formControls={this.formControls}
                             mutationParams={this.mutationParams}
                             redirectTo={this.redirectTo}/>
      );
    }
  }
}

export default Form.create()(graphql(createDailyScripture)(CreateScripturePage));




// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/createScripture.js